import Service from '../helpers/service';
import { ADD_PROFILE, ADD_CURRENT_ROUTE } from '../actionTypes';
import Helping from '../helpers/Helping';
import { API_URL } from '../config/urls';

export const addProfile = profile => ({
    type: ADD_PROFILE,
    profile
});

export const addCurrentRoute = (profile, route) => ({
    type: ADD_CURRENT_ROUTE,
    profile: {...profile, route}
});

let updateCallback = (res) => {

}


export const setProfileError = (callback) => {

    updateCallback = callback;

}

export const fetchProfile = () => {
    return dispatch => {
        return Service.getCall(API_URL.ADMIN_API + 'admin/profile').then(response => {
            dispatch(addProfile(response.data.payload))
            localStorage.setItem('profile', JSON.stringify(response.data.payload))
        }).catch(error => {
            console.log({
                error
            });
            Helping.isAuth(error.response);
            return updateCallback({
                ...Helping.setNetworkRequestError(error, "profile")
            });
        });
    }
};